import axios from 'axios';

axios.defaults.headers['Content-Type'] = 'application/json';
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: BASE_URL,
});
